<template>
  <div class="devices">

    <b-card no-body>
      <b-tabs v-model="tabIndex" card>

        <!-- Render Tabs, supply a unique `key` to each tab -->
        <b-tab v-for="(data, index) in locationTabs" :key="index" :title="data.alias">
          <location-pages ref="locationPages" 
                          :location="data" 
                          :selectedTab="tabIndex"/>
        </b-tab>

        <!-- Render this if no tabs -->
        <template v-slot:empty>
          <div class="text-center text-muted">
            Todavía no hay ninguna zona agregada<br>
            Agrege una nueva zona en la sección "Ubicaciones"
          </div>
        </template>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>

import LocationPages from './LocationPages';
import LocationService from "@/services/LocationService";
import UserService from '@/services/UserService';

export default {
    data () {
        return {
          tabIndex: 0,
          locationTabs: [],
          loaded: false
        }
    },
    components: {
      'location-pages': LocationPages
    },
    watch: {
      tabIndex: function () {
        if(this.loaded == true){
          this.$emit('selectLocation', this.locationTabs[this.tabIndex])
        }
      }
    },
    mounted() {
      this.retrieveLocation();
    },
    methods: {
      async retrieveLocation() {
        try {
          let responseSelect = await LocationService.getAll();
          this.locationTabs = responseSelect.data;
          this.loaded = true;
        } catch (error) {
          throw new Error('Error - DeviceList.vue - retrieveLocation' + error);
        } 
      },

      isUserAdmin(){
        return UserService.isUserAdmin();
      }
    }
}
</script>
